import React, {useEffect, useState} from "react";
import {Navigate} from "react-router-dom";
import Circles from "../components/MyComp/Circles";
import Carousel from "../components/MyComp/Carousel";
import {Header} from "../components/Header";
import Hero from "../components/MyComp/Hero";
import Footer from "../components/MyComp/Footer";
import NoticeBoard from "../components/NoticeBoard";
import Assistant from "./Assistant";
import {t} from "i18next";
import {useAuth} from "../hooks/useAuth";

export const LandingPageScreen = () => {
	const {isAuthenticated} = useAuth();
	const [isAssistantOpen, setIsAssistantOpen] = useState(false);

	const noticeBoardBanners = [
		{
			img: "/landingPage_banner/step1-joglekarkul-videotutorial.png",
			url: "/onboarding-tutorials",
		},
		{
			img: "/landingPage_banner/step2-joglekarkul-register.png",
			url: "/register"
		},
		{
			img: "https://jogkulstorageuat.blob.core.windows.net/siteassets/events/banners/699524167e176f515cf6727c.jpeg",
			url: "/news-and-events"
		}
		// {
		// 	img: "https://jogkulstorageuat.blob.core.windows.net/siteassets/events/banners/68ba68ec7db5e2a121dfc260.jpg",
		// 	url: "/news-and-events"
		// }
	];

	const featureSet1 = [
		{
			id: 1,
			title: t("HOME_PAGE.FEATURES_SECTION.GHARKUL"),
			img: "/kulvratant_landingPage/image-gharkul.png",
			href: "/gharkul",
			authenticationRequired: true
		},
		{
			id: 2,
			title: t("HOME_PAGE.FEATURES_SECTION.MEMORIES"),
			img: "/kulvratant_landingPage/image-memories.png",
			href: "/memories",
			authenticationRequired: true
		},
		{
			id: 3,
			title: t("HOME_PAGE.FEATURES_SECTION.YELLOW_PAGE"),
			img: "/kulvratant_landingPage/image-yellowpage.png",
			href: "/yellow-page",
			authenticationRequired: true
		},
		{
			id: 4,
			title: t("HOME_PAGE.FEATURES_SECTION.HELP_EACH_OTHER"),
			img: "/kulvratant_landingPage/image-help-each-other.png",
			href: '/help-each-other',
			authenticationRequired: true
		},
		{
			id: 5,
			title: t("HOME_PAGE.FEATURES_SECTION.PRIDE"),
			img: "/kulvratant_landingPage/image-pride.png",
			href: '/pride',
			authenticationRequired: false
		},
	];

	const featureSet2 = [
		{
			id: 6,
			title: t("HOME_PAGE.FEATURES_SECTION.BUSINESS_ASSISTANCE"),
			img: "/kulvratant_landingPage/image-business-assistance.png",
			href: "/",
			authenticationRequired: false
		},
		{
			id: 7,
			title: t("HOME_PAGE.FEATURES_SECTION.NATURE_WARRIOR"),
			img: "/kulvratant_landingPage/image-nature-warriors.png",
			href: "/nature-warriors",
			authenticationRequired: false
		},
		{
			id: 8,
			title: t("HOME_PAGE.FEATURES_SECTION.ANUROOP_JODIDAR"),
			img: "/kulvratant_landingPage/image-matrimonial.png",
			href: "/anuroop-jodidar",
			authenticationRequired: true
		},
		{
			id: 9,
			title: t("HOME_PAGE.FEATURES_SECTION.ASSISTANCE"),
			img: "/kulvratant_landingPage/image-assistant-sahayak.png",
			href: "",
			authenticationRequired: false
		},
		{
			id: 10,
			title: t("HOME_PAGE.FEATURES_SECTION.MEMBERSHIP"),
			img: "/kulvratant_landingPage/image-sabhasad.png",
			href: "/membership",
			authenticationRequired: false
		},
	];

	useEffect(() => {
		// Scroll to top when the page is rendered
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="bg-white">
			<Navigate to="/home" replace={true}/>

			{/* Header */}
			<Header/>

			<main className="isolate">
				{/* Hero section */}
				<Hero/>

				{/* Notice Board Section */}
				<NoticeBoard
					banners={
						!isAuthenticated
							? noticeBoardBanners
							: noticeBoardBanners.filter((banner) => banner.url !== "/register")
					}
				/>

				{/* Carousel Section */}
				<div className="wave bg-[#750534] py-10 md:-mt-10 -mt-[30px] ">
					<Carousel/>
				</div>

				{/* Circle Icon Section */}
				<div className="wave">
					<div className="bg-[#ffe5d2] py-10 md:-mt-10 -mt-[60px] ">
						<div
							className={`flex flex-col md:flex-row items-center 
                                justify-center text-center gap-x-[6vw] m-10`}
						>
							{featureSet1.map((data) => (
								<Circles
									key={data.id}
									data={data}
									onAssistantOpen={() => setIsAssistantOpen(true)}
								/>
							))}
						</div>

						<div
							className={`flex flex-col md:flex-row items-center 
                                justify-center text-center gap-x-[6vw] m-10`}
						>
							{featureSet2.map((data) => (
								<Circles
									key={data.id}
									data={data}
									onAssistantOpen={() => setIsAssistantOpen(true)}
								/>
							))}
						</div>

						<Assistant open={isAssistantOpen} setOpen={setIsAssistantOpen}/>
					</div>
				</div>

				{/* Footer */}
				<Footer/>
			</main>
		</div>
	);
};
